import { ExperienceColor } from '@/lib/schemas/experience-colors';
import create from 'zustand';

interface ExperienceColorsStore {
  experienceColors: ExperienceColor[] | null;
  setExperienceColors: (experienceColors: ExperienceColor[] | null) => void;
}

export const useExperienceColorsStore = create<ExperienceColorsStore>(
  (set) => ({
    experienceColors: null,
    setExperienceColors: (experienceColors) => set({ experienceColors }),
  })
);
